module.exports = __webpack_public_path__ + "static/media/remiseWEB.0267e791.png";